import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
const initialTestimonials = {
    doula: [
        {
            id: '1',
            name: 'Sarah M.',
            initials: 'S.M.',
            content: 'Madison\'s presence during my birth was absolutely transformative. She held space with such reverence and trust in my body\'s wisdom. I felt completely supported and empowered throughout my entire labor.',
            service: 'doula',
            visible: true
        },
        {
            id: '2',
            name: 'Emily R.',
            initials: 'E.R.',
            content: 'Having Madison as my doula was like having a wise, loving sister by my side. She knew exactly when to offer support and when to step back. My birth experience was exactly what I needed.',
            service: 'doula',
            visible: true
        },
        {
            id: '3',
            name: 'T.C.',
            initials: 'T.C.',
            content: 'Madison is a goddess of a doula who goes above and beyond. She helped me realize my own strength, and I am forever grateful for her contribution to my birth. Because of her my delivery and aftercare was nothing short of magical!',
            service: 'doula',
            visible: true
        }
    ],
    sacredMotherhood: [
        {
            id: '1',
            name: 'Jennifer L.',
            initials: 'J.L.',
            content: 'The Sacred Motherhood Journey program completely changed my perspective on birth and motherhood. I felt so prepared and connected to my intuition. Madison\'s guidance was gentle yet profound.',
            service: 'sacredMotherhood',
            visible: true
        },
        {
            id: '2',
            name: 'Amanda R.',
            initials: 'A.R.',
            content: 'Madison\'s Sacred Motherhood Journey program completely changed my perspective on birth and motherhood. I felt so empowered and prepared for my birth experience.',
            service: 'sacredMotherhood',
            visible: true
        }
    ],
    reiki: [],
    prenatalYoga: [],
    postnatalYoga: [
        {
            id: '1',
            name: 'Melissa T.',
            initials: 'M.T.',
            content: 'Postnatal yoga with Madison helped me reconnect with my body after birth. Her gentle guidance and understanding of postpartum recovery made all the difference.',
            service: 'postnatalYoga',
            visible: true
        }
    ]
};
const initialResources = [
    {
        id: "digital-downloads",
        title: "Digital Downloads",
        description: "Guides, meditations, and practices to support your journey",
        icon: "/assets/icons/Downloads.svg",
        visible: true,
        items: [
            {
                id: "sacred-motherhood-guide",
                name: "Sacred Motherhood Starter Guide",
                description: "A gentle introduction to sacred motherhood practices",
                price: "$7",
                status: "coming-soon",
                image: "/assets/SERVICE_Sacred1.png",
                category: "digital-downloads",
                visible: true
            },
            {
                id: "prenatal-yoga-sequence",
                name: "Prenatal Yoga Sequence",
                description: "Complete 30-minute prenatal yoga flow with modifications",
                price: "$5",
                status: "coming-soon",
                image: "/assets/SERVICE_doula.png",
                category: "digital-downloads",
                visible: false
            },
            {
                id: "reiki-self-care",
                name: "Reiki Self-Care Ritual",
                description: "Learn simple energy healing techniques for daily use",
                price: "$8",
                status: "coming-soon",
                image: "/assets/SERVICE_womensCircle.png",
                category: "digital-downloads",
                visible: false
            }
        ]
    },
    {
        id: "printables",
        title: "Printable Resources",
        description: "Journals, planners, and affirmation cards",
        icon: "/assets/icons/print.svg",
        visible: true,
        items: [
            {
                id: "postpartum-journal",
                name: "Postpartum Wellness Journal",
                description: "30-day guided journal for postpartum healing",
                price: "$12",
                status: "coming-soon",
                image: "/assets/SERVICE_Sacred1.png",
                category: "printables",
                visible: false
            },
            {
                id: "affirmation-cards",
                name: "Sacred Motherhood Affirmation Cards",
                description: "Printable cards with daily affirmations",
                price: "$6",
                status: "coming-soon",
                image: "/assets/SERVICE_doula.png",
                category: "printables",
                visible: true
            }
        ]
    },
    {
        id: "bundles",
        title: "Complete Bundles",
        description: "Curated collections for specific needs",
        icon: "🎁",
        visible: true,
        items: [
            {
                id: "birth-preparation-bundle",
                name: "Birth Preparation Bundle",
                description: "Complete guide with meditations, yoga, and affirmations",
                price: "$25",
                status: "coming-soon",
                image: "/assets/SERVICE_womensCircle.png",
                category: "bundles",
                visible: false
            },
            {
                id: "sacred-motherhood-kit",
                name: "Sacred Motherhood Complete Kit",
                description: "Everything you need for your sacred motherhood journey",
                price: "$35",
                status: "coming-soon",
                image: "/assets/SERVICE_Sacred1.png",
                category: "bundles",
                visible: false
            }
        ]
    },
    {
        id: "recommended-products",
        title: "Recommended Products",
        description: "Tools and resources I trust and use",
        icon: "🛍️",
        visible: true,
        items: [
            {
                id: "yoga-props",
                name: "Yoga Props & Equipment",
                description: "Essential items for prenatal and postnatal practice",
                price: "Varies",
                status: "affiliate",
                image: "/assets/SERVICE_doula.png",
                category: "recommended-products",
                visible: false
            },
            {
                id: "wellness-products",
                name: "Natural Wellness Products",
                description: "Organic teas, essential oils, and healing tools",
                price: "Varies",
                status: "affiliate",
                image: "/assets/SERVICE_womensCircle.png",
                category: "recommended-products",
                visible: false
            }
        ]
    }
];
const initialContentState = {
    services: [
        { id: 'doula', name: 'Doula Services', path: '/doula', visible: true, adminOnly: false, description: 'Compassionate, hands-on support from pregnancy through postpartum—honoring your birth vision and emotional well-being.' },
        { id: 'sacred-motherhood', name: 'Sacred Motherhood Journey', path: '/sacred-motherhood', visible: true, adminOnly: false, description: 'A five-session immersion, weaving energy balancing, embodiment, and holistic wellness to ready your body, mind, and spirit for the path ahead.' },
        { id: 'gallery', name: 'Gallery', path: '/gallery', visible: true, adminOnly: false, description: 'A collection of beautiful moments from the sacred journey of birth.' },
        { id: 'womens-circles', name: 'Women\'s Circles', path: '/womens-circles', visible: false, adminOnly: false, description: 'Sacred spaces for women to connect and grow.' },
        { id: 'reiki', name: 'Reiki Therapy', path: '/reiki', visible: false, adminOnly: true, description: 'Energy healing for balance and well-being.' },
        { id: 'prenatal-yoga', name: 'Prenatal Yoga', path: '/prenatal-yoga', visible: false, adminOnly: true, description: 'Gentle yoga for expectant mothers.' },
        { id: 'postnatal-yoga', name: 'Postnatal Yoga', path: '/postnatal-yoga', visible: false, adminOnly: true, description: 'Restorative yoga for postpartum recovery.' },
    ],
    resources: initialResources,
    testimonials: initialTestimonials,
    intakeForms: {
        reiki: false,
        yoga: false,
        reikiIntakeForm: false
    },
    supportButtons: {
        visible: false
    }
};
const ContentContext = createContext(undefined);
export const useContent = () => {
    const context = useContext(ContentContext);
    if (context === undefined) {
        throw new Error('useContent must be used within a ContentProvider');
    }
    return context;
};
export const ContentProvider = ({ children }) => {
    // Use existing localStorage content or defaults
    // useEffect(() => {
    //   localStorage.removeItem('content');
    // }, []);
    const [content, setContent] = useState(() => {
        const saved = localStorage.getItem('content');
        const parsed = saved ? JSON.parse(saved) : initialContentState;
        // Ensure all required properties exist with fallbacks
        return Object.assign(Object.assign(Object.assign({}, initialContentState), parsed), { supportButtons: Object.assign({ visible: false }, parsed.supportButtons), intakeForms: Object.assign({ reiki: false, yoga: false, reikiIntakeForm: false }, parsed.intakeForms) });
    });
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    useEffect(() => {
        localStorage.setItem('content', JSON.stringify(content));
    }, [content]);
    const updateContent = (updates) => {
        setContent(prev => (Object.assign(Object.assign({}, prev), updates)));
    };
    const addTestimonial = (service, testimonial) => {
        const newTestimonial = Object.assign(Object.assign({}, testimonial), { id: Date.now().toString(), service });
        setContent(prev => (Object.assign(Object.assign({}, prev), { testimonials: Object.assign(Object.assign({}, prev.testimonials), { [service]: [...(prev.testimonials[service] || []), newTestimonial] }) })));
    };
    const removeTestimonial = (service, testimonialId) => {
        setContent(prev => (Object.assign(Object.assign({}, prev), { testimonials: Object.assign(Object.assign({}, prev.testimonials), { [service]: (prev.testimonials[service] || []).filter(t => t.id !== testimonialId) }) })));
    };
    const toggleTestimonialVisibility = (service, testimonialId) => {
        setContent(prev => (Object.assign(Object.assign({}, prev), { testimonials: Object.assign(Object.assign({}, prev.testimonials), { [service]: (prev.testimonials[service] || []).map(t => t.id === testimonialId ? Object.assign(Object.assign({}, t), { visible: !t.visible }) : t) }) })));
    };
    const toggleResourceVisibility = (categoryId, resourceId) => {
        setContent(prev => (Object.assign(Object.assign({}, prev), { resources: prev.resources.map(category => category.id === categoryId
                ? Object.assign(Object.assign({}, category), { items: category.items.map(item => item.id === resourceId
                        ? Object.assign(Object.assign({}, item), { visible: !item.visible }) : item) }) : category) })));
    };
    const toggleResourceCategoryVisibility = (categoryId) => {
        setContent(prev => (Object.assign(Object.assign({}, prev), { resources: prev.resources.map(category => category.id === categoryId
                ? Object.assign(Object.assign({}, category), { visible: !category.visible }) : category) })));
    };
    const login = (password) => {
        if (password === 'admin123') {
            setIsAuthenticated(true);
            return true;
        }
        return false;
    };
    const value = {
        content,
        updateContent,
        addTestimonial,
        removeTestimonial,
        toggleTestimonialVisibility,
        toggleResourceVisibility,
        toggleResourceCategoryVisibility,
        login,
        isAuthenticated
    };
    return (_jsx(ContentContext.Provider, { value: value, children: children }));
};
